import { type_of_use_enum } from '@predium/enums';

export const commonAreaRatios: Record<type_of_use_enum, number> = {
  [type_of_use_enum.MFH]: 0.25,
  [type_of_use_enum.COMMUNAL_ACCOMMODATION]: 0.25,
  [type_of_use_enum.DORM]: 0.25,
  [type_of_use_enum.SFH]: 0.055,
  [type_of_use_enum.HOTEL]: 0.2,
  [type_of_use_enum.SHOPPING_CENTER]: 0.25,
  [type_of_use_enum.DATA_CENTER]: 0.03,
  [type_of_use_enum.COLD_WAREHOUSE]: 0.03,
  [type_of_use_enum.GYM]: 0.03,
  [type_of_use_enum.OUTDOOR_SPORT_FACILITY]: 0.03,
  [type_of_use_enum.SPORT_AND_LEISURE_BUILDING]: 0.03,
  [type_of_use_enum.RIDING_AND_ICE_SPORT_HALL]: 0.03,
  [type_of_use_enum.VEHICLE_STORAGE_HALL]: 0.03,
  [type_of_use_enum.VEHICLE_SERVICE_AND_INSPECTION_FACILITY]: 0.03,
  [type_of_use_enum.TRANSPORT_TERMINAL]: 0.03,
  [type_of_use_enum.EXHIBITION_HALL]: 0.03,
  [type_of_use_enum.EVENT_HALL]: 0.03,
  [type_of_use_enum.LEISURE_AND_COMMUNITY_FACILITY]: 0.03,
  [type_of_use_enum.EXHIBITION_BUILDING]: 0.03,
  [type_of_use_enum.LIBRARY]: 0.03,
  [type_of_use_enum.CENTRAL_SERVICE_BUILDING]: 0.03,
  [type_of_use_enum.LOGISTIC_STORAGE_OPERATION_BUILDING]: 0.03,
  [type_of_use_enum.PRODUCTION_AND_WORKSHOP_BUILDING]: 0.03,
  [type_of_use_enum.LECTURE_AND_TEACHING_BUILDING]: 0.03,
  [type_of_use_enum.PARKING_GARAGE]: 0.25,
  [type_of_use_enum.UTILITY_AND_INFRASTRUCTURE_BUILDING]: 0.25,
  [type_of_use_enum.VEHICLE_FLEET_FACILITY]: 0.25,
  [type_of_use_enum.FIRE_DEPARTMENT]: 0.25,
  [type_of_use_enum.UNIVERSITY_AND_RESEARCH_INSTITUTION]: 0.25,
  [type_of_use_enum.POLICE_STATION]: 0.25,
  [type_of_use_enum.ADMINISTRATIVE_BUILDING]: 0.25,
  [type_of_use_enum.EDUCATION_INSTITUTION]: 0.25,
  [type_of_use_enum.YOUTH_CENTER]: 0.25,
  [type_of_use_enum.RETAIL_NON_FOOD]: 0.03,
  [type_of_use_enum.UTILITY_SERVICE_BUILDING]: 0.03,
  [type_of_use_enum.CAFETERIA]: 0.03,
  [type_of_use_enum.RESTAURANT]: 0.03,
  [type_of_use_enum.REHABILITATION_CENTER]: 0.25,
  [type_of_use_enum.DOCTOR_OFFICE]: 0.25,
  [type_of_use_enum.MEDICAL_AND_NURSING_FACILITY]: 0.25,
  [type_of_use_enum.LABORATORY_AND_RESEARCH_BUILDING]: 0.25,
  [type_of_use_enum.ELDERLY_DAYCARE_CENTER]: 0.25,
  [type_of_use_enum.RETAIL_FOOD]: 0.03,
};

export const commonAreaRange: Record<type_of_use_enum, [number, number]> = {
  [type_of_use_enum.MFH]: [0.2, 0.3],
  [type_of_use_enum.COMMUNAL_ACCOMMODATION]: [0.2, 0.3],
  [type_of_use_enum.DORM]: [0.2, 0.3],
  [type_of_use_enum.SFH]: [0.01, 0.1],
  [type_of_use_enum.HOTEL]: [0.01, 0.25],
  [type_of_use_enum.SHOPPING_CENTER]: [0.01, 0.3],
  [type_of_use_enum.DATA_CENTER]: [0.01, 0.05],
  [type_of_use_enum.COLD_WAREHOUSE]: [0.01, 0.05],
  [type_of_use_enum.GYM]: [0.01, 0.05],
  [type_of_use_enum.OUTDOOR_SPORT_FACILITY]: [0.01, 0.05],
  [type_of_use_enum.SPORT_AND_LEISURE_BUILDING]: [0.01, 0.05],
  [type_of_use_enum.RIDING_AND_ICE_SPORT_HALL]: [0.01, 0.05],
  [type_of_use_enum.VEHICLE_STORAGE_HALL]: [0.01, 0.05],
  [type_of_use_enum.VEHICLE_SERVICE_AND_INSPECTION_FACILITY]: [0.01, 0.05],
  [type_of_use_enum.TRANSPORT_TERMINAL]: [0.01, 0.05],
  [type_of_use_enum.EXHIBITION_HALL]: [0.01, 0.05],
  [type_of_use_enum.EVENT_HALL]: [0.01, 0.05],
  [type_of_use_enum.LEISURE_AND_COMMUNITY_FACILITY]: [0.01, 0.05],
  [type_of_use_enum.EXHIBITION_BUILDING]: [0.01, 0.05],
  [type_of_use_enum.LIBRARY]: [0.01, 0.05],
  [type_of_use_enum.CENTRAL_SERVICE_BUILDING]: [0.01, 0.05],
  [type_of_use_enum.LOGISTIC_STORAGE_OPERATION_BUILDING]: [0.01, 0.05],
  [type_of_use_enum.PRODUCTION_AND_WORKSHOP_BUILDING]: [0.01, 0.05],
  [type_of_use_enum.LECTURE_AND_TEACHING_BUILDING]: [0.01, 0.05],
  [type_of_use_enum.PARKING_GARAGE]: [0.01, 0.3],
  [type_of_use_enum.UTILITY_AND_INFRASTRUCTURE_BUILDING]: [0.01, 0.3],
  [type_of_use_enum.VEHICLE_FLEET_FACILITY]: [0.01, 0.3],
  [type_of_use_enum.FIRE_DEPARTMENT]: [0.01, 0.3],
  [type_of_use_enum.UNIVERSITY_AND_RESEARCH_INSTITUTION]: [0.01, 0.3],
  [type_of_use_enum.POLICE_STATION]: [0.01, 0.3],
  [type_of_use_enum.ADMINISTRATIVE_BUILDING]: [0.01, 0.3],
  [type_of_use_enum.EDUCATION_INSTITUTION]: [0.01, 0.3],
  [type_of_use_enum.YOUTH_CENTER]: [0.01, 0.3],
  [type_of_use_enum.RETAIL_NON_FOOD]: [0.01, 0.05],
  [type_of_use_enum.UTILITY_SERVICE_BUILDING]: [0.01, 0.05],
  [type_of_use_enum.CAFETERIA]: [0.01, 0.05],
  [type_of_use_enum.RESTAURANT]: [0.01, 0.05],
  [type_of_use_enum.REHABILITATION_CENTER]: [0.01, 0.35],
  [type_of_use_enum.DOCTOR_OFFICE]: [0.01, 0.35],
  [type_of_use_enum.MEDICAL_AND_NURSING_FACILITY]: [0.01, 0.35],
  [type_of_use_enum.LABORATORY_AND_RESEARCH_BUILDING]: [0.01, 0.35],
  [type_of_use_enum.ELDERLY_DAYCARE_CENTER]: [0.01, 0.35],
  [type_of_use_enum.RETAIL_FOOD]: [0.01, 0.05],
};

/**
 * min/max range due to GRESB for buildings of mixed use.
 */
export const mixedUseGRESBAreaRange = [0.05, 0.3];
